import { Queue, Api } from "@/plugins/api"
export default {

  state: () => ({
    panier: undefined,
    panierUpdating: false,
  }),

  getters: {
    panier: (state) => {
      return state.panier
    },
    panierUpdating: (state) => {
      return state.panierUpdating
    },
    montantTotalArrondi: (state) => {
      return Math.round(state.panier.total.prix * 100) / 100
    },
    montant1de2: (state, getters) => {
      return Math.round(getters.montantTotalArrondi / 2 * 100) / 100
    },
    montant2de2: (state, getters) => {
      return getters.montantTotalArrondi - getters.montant1de2
    },

  },
  mutations: {
    SET_PANIER(state, panier) {
      state.panier = panier
    },
    SET_PANIER_UPDATING(state, panierUpdating) {
      state.panierUpdating = panierUpdating
    },
  },
  actions: {
    async fetchPanier({ commit }, sasId) {
      commit("SET_PANIER_UPDATING", true);
      return Queue.enqueue(() =>
        Api.get("sas/estimation/" + sasId)
          .then((res) => {
            commit("SET_PANIER", res.data)
          })
          .finally(() => {
            commit("SET_PANIER_UPDATING", false);
          })
        , 9)
    }
  }
}